const STEPS = [
  { n: "01", title: "Listen", desc: "We start with a conversation. No script, no pressure — just understanding where you are and where you want to go." },
  { n: "02", title: "Assess", desc: "A clear-eyed look at the opportunities and obstacles. We tell you the truth, even when it's not what you hoped to hear." },
  { n: "03", title: "Build", desc: "We design and deploy the right system for your venture — websites, marketing, deals, or strategy. Quietly excellent work." },
  { n: "04", title: "Sustain", desc: "We stay close as things scale. Adjust. Refine. Add new income streams when the foundation is ready." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="overline mb-4">// THE_BLUEPRINT</div>
            <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
              Four steps.<br />
              <span className="text-neon-cyan neon-text-cyan">No theatrics.</span>
            </h2>
          </div>
          <p className="lg:col-span-7 text-white/60 text-base md:text-lg max-w-2xl">
            We don&apos;t sell courses or chase trends. We do the work — quietly, consistently — and we expect the same of the people we partner with. <span className="text-white">The process is simple. The standards are not.</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {STEPS.map((step, i) => (
            <div
              key={step.n}
              data-testid={`process-step-${i}`}
              className="group bg-[#05050A] p-8 md:p-10 hover:bg-white/[0.03] transition-all relative overflow-hidden"
            >
              <div className="font-mono text-6xl md:text-7xl font-bold text-white/10 group-hover:text-neon-cyan/30 transition-colors mb-6">
                {step.n}
              </div>
              <h3 className="font-heading font-bold text-2xl mb-3">{step.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{step.desc}</p>
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-cyan to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
